<template>
  <form @submit.prevent="filterSubject()" action="">
    <ion-row>
      <ion-col size="12">
        <ion-list>
          <ion-item v-if="validationError" lines="none">
            <ion-label className="ion-text-wrap">
              <ion-text color="danger">
                <p v-for="error of v$.$errors" :key="error.$uid">
                  <ion-icon
                    :ios="alertCircleOutline"
                    :md="alertCircleSharp"
                    size="small"
                    style="vertical-align: middle"
                  ></ion-icon
                  >{{ error.$property }}: {{ error.$message }}
                </p></ion-text
              >
            </ion-label>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.standard_id.$error }">
            <ion-label position="floating">Standard</ion-label>
            <ion-select v-model="standard_id" :value="standard_id">
              <ion-select-option
                v-for="standard of standards"
                :key="standard.id"
                :value="standard.id"
              >
                {{ standard.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.subject_group_id.$error }">
            <ion-label position="floating">Subject Group</ion-label>
            <ion-select v-model="subject_group_id" :value="subject_group_id">
              <ion-select-option
                v-for="item of subjectGroups"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item :class="{ 'color-danger': v$.exam_schedule_id.$error }">
            <ion-label position="floating">Exam schedule</ion-label>
            <ion-select
              :interface-options="{ cssClass: 'full-screen' }"
              v-if="exam_schedules.length > 0"
              v-model="exam_schedule_id"
            >
              <ion-select-option
                v-for="item of exam_schedules"
                :key="item.id"
                :value="item.id"
              >
                {{ moment(item.start).format("ll") }}
                {{ moment(item.start).format("LT") }} to
                {{ moment(item.end).format("LT") }}
              </ion-select-option>
            </ion-select>
            <ion-select v-else disabled>
              <ion-select-option> No Schedule exists </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="6">
        <ion-button
          type="button"
          expand="full"
          color="warning"
          class="ion-margin-vertical"
          @click="resetFilters"
        >
          Reset
        </ion-button>
      </ion-col>
      <ion-col size="6">
        <ion-button type="submit" expand="full" class="ion-margin-vertical">
          Save
        </ion-button>
      </ion-col>
    </ion-row>
  </form>
</template>

<script>
import {
  IonRow,
  IonCol,
  IonList,
  IonLabel,
  IonItem,
  IonSelect,
  IonSelectOption,
  IonIcon,
  IonButton,
  IonText,
  loadingController,
  alertController,
} from "@ionic/vue";

// import { alertCircleOutline, alertCircleSharp } from "ionicons/icons";

import { integer, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import moment from "moment";

export default {
  emits: ["closeModal"],
  props: ["exam_id"],
  components: {
    IonRow,
    IonCol,
    IonList,
    IonLabel,
    IonItem,
    IonSelect,
    IonSelectOption,
    IonIcon,
    IonButton,
    IonText,
  },
  data() {
    return {
      subject_group_id: null,
      standard_id: null,
      exam_schedule_id: null,

      validationError: null,

      moment,

      // alertCircleOutline,
      // alertCircleSharp,

      // xhrError: {
      //   header: null,
      //   description: null,
      // },
    };
  },

  computed: {
    standards() {
      return this.$store.getters["standard/allResources"];
    },
    subjectGroups() {
      return this.$store.getters["subjectGroup/allResources"];
    },
    exam_schedules() {
      return this.$store.getters["examSchedule/allResources"];
    },
    filters() {
      return this.$store.getters["examSubject/filters"];
    },
  },

  setup() {
    return { v$: useVuelidate() };
  },

  validations() {
    return {
      standard_id: {
        integer: helpers.withMessage("can only be integers", integer),
      },
      subject_group_id: {
        integer: helpers.withMessage("can only be integers", integer),
      },
      exam_schedule_id: {
        integer: helpers.withMessage("can only be integers", integer),
      },
    };
  },

  methods: {
    setModalState(state) {
      this.modalState = state;
    },

    loader(message) {
      const loading = loadingController.create({
        message: message,
        backdropDismiss: false,
      });

      return loading;
    },

    alerter(header, message, buttons = ["close"]) {
      const alert = alertController.create({
        header: header,
        message: message,
        buttons: buttons,
      });

      return alert;
    },

    setErrorResponse(error) {
      if (error.response) {
        this.xhrError.header = error.response.data.header;
        this.xhrError.message = error.response.data.message;
      } else if (error.request) {
        this.xhrError.header = error.message || error.request;
        this.xhrError.message = "Please check your connection and try again";
      } else {
        this.xhrError.header = error.message;
        this.xhrError.message = "Something went wrong. Try again later";
      }
    },

    async filterSubject() {
      this.v$.$touch();
      if (this.v$.$error) {
        this.validationError = true;
        return;
      }

      let data = {
        exam_id: this.exam_id,
        standard_id: this.standard_id,
        subject_group_id: this.subject_group_id,
        exam_schedule_id: this.exam_schedule_id,
      };

      const spinner = await this.loader("Saving...");
      spinner.present();

      try {
        await this.$store.dispatch("examSubject/filters", data);
        spinner.dismiss();
        this.$emit("closeModal");
      } catch (error) {
        spinner.dismiss();
        this.setErrorResponse(error);
        const alertDialog = await this.alerter(
          this.xhrError.header,
          this.xhrError.message
        );
        alertDialog.present();
        this.validationError = null;
      }
    },

    async fetchStandards() {
      await this.$store.dispatch("standard/allResources");
      this.standard_id = this.filters.standard_id;
    },

    async fetchSubjectGroups() {
      await this.$store.dispatch("subjectGroup/allResources");
      this.subject_group_id = this.filters.subject_group_id;
    },

    async fetchSchedules() {
      await this.$store.dispatch("examSchedule/allResources", this.exam_id);
      this.exam_schedule_id = this.filters.exam_schedule_id;
    },

    resetFilters() {
      this.standard_id = null;
      this.subject_group_id = null;
      this.exam_schedule_id = null;
    },
  },

  created() {
    this.fetchStandards();
    this.fetchSubjectGroups();
    this.fetchSchedules();
  },
};
</script>